"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Icon_1 = __importDefault(require("../Icon"));
var Typography_1 = __importDefault(require("../Typography"));
var styles_1 = require("./styles");
var Accordion = function (_a) {
    var children = _a.children, label = _a.label, testId = _a.testId, additionalContent = _a.additionalContent, controlledIsExpanded = _a.isExpanded, onToggle = _a.onToggle;
    var _b = (0, react_1.useState)(false), uncontrolledIsExpanded = _b[0], setUncontrolledIsExpanded = _b[1];
    var isExpanded = controlledIsExpanded !== undefined ? controlledIsExpanded : uncontrolledIsExpanded;
    var handleAccordionToggle = function () {
        if (onToggle && controlledIsExpanded !== undefined) {
            onToggle(!isExpanded);
        }
        else {
            onToggle === null || onToggle === void 0 ? void 0 : onToggle(!uncontrolledIsExpanded);
            setUncontrolledIsExpanded(function (value) { return !value; });
        }
    };
    var accordionLabel = ((0, jsx_runtime_1.jsx)(Typography_1.default.Body, __assign({ "data-testid": "".concat(testId, "-label"), size: "lg" }, { children: label })));
    var content = ((0, jsx_runtime_1.jsx)(styles_1.Content, __assign({ size: "lg", "data-testid": "".concat(testId, "-content") }, { children: children })));
    var baseAccordion = ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)(styles_1.Opener, __assign({ onClick: handleAccordionToggle, "data-testid": "".concat(testId, "-opener") }, { children: [accordionLabel, (0, jsx_runtime_1.jsx)(Icon_1.default, { name: isExpanded ? 'chevron-up' : 'chevron-down' })] })), isExpanded && content] }));
    var toggleAccordion = ((0, jsx_runtime_1.jsxs)(styles_1.Container, { children: [(0, jsx_runtime_1.jsxs)(styles_1.ToggleOpener, { children: [accordionLabel, (0, jsx_runtime_1.jsxs)(styles_1.RightContent, { children: [additionalContent, (0, jsx_runtime_1.jsx)(styles_1.IconWrapper, __assign({ onClick: handleAccordionToggle, "data-testid": "".concat(testId, "-opener") }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: isExpanded ? 'chevron-up' : 'chevron-down' }) }))] })] }), isExpanded && content] }));
    return additionalContent ? toggleAccordion : baseAccordion;
};
exports.default = Accordion;
